import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';

const state = {
    rptPercepciones: []
};

const mutations = {
    updateField,

    'INICIALIZAR_RPT' (state) {
        state.rptPercepciones = [];
    },
    'SET_RPT' (state, rptPercepciones) {
        state.rptPercepciones = rptPercepciones;
    },
};

const getters = {
    getField,

    rptPercepciones (state) {
        return state.rptPercepciones;
    }
};

const actions = {
    getRptPercepcionesCompras ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT');

            let queryString = '?fechaDesde='+ moment(params.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(params.fechaHasta).format('YYYY-MM-DD');

            // if (params.proveedorId) {
            //     if (params.proveedorId != 0) {
            //         queryString += '&proveedorId=' + params.proveedorId;
            //     }
            // }
                    
            apiAxios.get('compras/rpt/percepciones/ii-bb' + queryString)
                .then(res => {
                    commit('SET_RPT', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}